import { render, staticRenderFns } from "./CarMaintenanceInfoDialog.vue?vue&type=template&id=5625f34a&scoped=true"
import script from "./CarMaintenanceInfoDialog.vue?vue&type=script&lang=js"
export * from "./CarMaintenanceInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5625f34a",
  null
  
)

export default component.exports